import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import structure from '@/structure'
import { breakpoints, colors } from '@/styles'
import { Button } from '@/components/button'

import { SectionTitle, SectionWrapper } from '../elements'

const Wrapper = styled(SectionWrapper)``

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  scroll-margin-top: ${structure.header.height}px;
  gap: 48px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    flex-direction: column-reverse;
    align-items: flex-start;
    scroll-margin-top: ${structure.header.heightMobile}px;
    gap: 32px;
  }
`

const ImageWrapper = styled.div`
  max-width: 575px;
  flex: 1;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    max-width: unset;
    margin: 0;
  }
`

const TextWrapper = styled.div`
  max-width: 600px;
  flex: 1;
`

const BodyText = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  margin: 0 0 28px 0;
`

const ImageDescription = styled.p`
  font-family: 'Inter';
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;

  text-align: center;
  margin: 0;
  color: ${colors.grey40};
`

const PropertyManagers = () => {
  const { t } = useTranslation()

  const handleLearnMore = () => {
    window.open('https://landlords.liv.rent/propertymanagers/', '_blank')
  }

  return (
    <Wrapper>
      <InnerWrapper>
        <TextWrapper>
          <SectionTitle marginBottom={16}>
            {t('landlords:Hey, Property Managers!')}
          </SectionTitle>
          <BodyText>
            {t(`landlords:Streamline and scale your team’s operations with business-minded
            solutions like digital rent collection, customizable lease addendums
            and user management.`)}
          </BodyText>
          <Button
            theme="primary"
            id="landlord-pm-learn-click"
            onClick={handleLearnMore}
          >
            {t('landlords:Learn more')}
          </Button>
        </TextWrapper>
        <ImageWrapper>
          <video
            style={{ objectFit: 'contain', width: '100%' }}
            autoPlay
            playsInline
            preload="auto"
            muted
          >
            <source src="/videos/hey-property-managers.mp4" type="video/mp4" />
          </video>
          <ImageDescription>
            {t(
              'landlords:Create contract addendums and manage users with ease!'
            )}
          </ImageDescription>
        </ImageWrapper>
      </InnerWrapper>
    </Wrapper>
  )
}

export default PropertyManagers
